import PdfHero from './PdfHero';
import PdfInfo from './PdfInfo';

const PdfContent = ({
  textColor, heroStyle, theme, walimatulurus, H2, fontP, H2size, groomName,
  brideName, weddingDate, walimatulurus2, parentName, message, groomFullname, brideFullname, 
  location, startTime, endTime, contacts, url, contentRef, handleDownloadPDF
}) => (
  <div className={`overflow-hidden ${fontP} w-[105mm] mx-auto`}>
    <div ref={contentRef}>
      <div className='space-y-4 py-8'>
        <h2 className='text-xl font-bold text-center'>Page 1</h2>
        <PdfHero {...{ theme, walimatulurus, H2, fontP, H2size, groomName, brideName, weddingDate, textColor }} />
      </div>
      <div className='space-y-4 py-8'>
        <h2 className='text-xl font-bold text-center'>Page 2</h2>
        <PdfInfo {...{ theme, walimatulurus2, parentName, message, groomFullname, brideFullname, H2, fontP, location, startTime, endTime, weddingDate, heroStyle, contacts, url, textColor }} />
      </div>
    </div>
    <button
      onClick={handleDownloadPDF}
      className="fixed bottom-4 py-4 bg-primary hover:bg-secondary text-highlight text-lg rounded-lg w-[300px] left-1/2 transform -translate-x-1/2 z-20"
    >
      Save as PDF
    </button>
  </div>
);

export default PdfContent;
